import { Box, Grid, StackProps } from "@mui/material";
import useHeaderHeight from "src/hooks/dom/useHeaderHeight";
import { ContainerSize } from "src/lib/utils/types";
import SalifyScrollableSideNavbarDefault from "../side-navbar/common/scrollable-side-navbar/default";
import SalifyStackWrapper from "../stack-wrapper/default";
import { SalifyContainerWrapper } from "../ui/container-wrapper/container-wrapper";

const gridColTotal = 12; // Tổng cột số cột bao quanh Grid
const defaultSideNavbarColSpan = 4; // Số cột chứa Sidebar
/** MUI default spacing(2); avoid importing theme.ts (pulls Roboto into every page). */
const defaultGridContainerPadding = "16px";

export interface VariantProps {
  sideNavbarColSpan?: any;
  containerSize?: ContainerSize;
  topSection?: {
    stackProps: StackProps;
    containerSize?: ContainerSize | undefined;
    components: any[];
  };
  content?: {
    stackProps: StackProps;
    components: any[];
  };
}

const PageWithStickySideNavbarDefault: React.FC<VariantProps> = ({
  sideNavbarColSpan,
  containerSize,
  content,
  topSection,
}) => {
  const headerHeight = useHeaderHeight();
  const sideNavbarSpan = !isNaN(Number.parseInt(sideNavbarColSpan))
    ? Number.parseInt(sideNavbarColSpan)
    : defaultSideNavbarColSpan;
  const contentSpan = Math.abs(gridColTotal - sideNavbarSpan);

  return (
    <>
      {!!topSection?.components?.length && (
        <SalifyStackWrapper
          components={topSection.components}
          containerSize={topSection.containerSize}
          stackProps={topSection.stackProps}
        />
      )}

      <SalifyContainerWrapper containerSize={containerSize}>
        <Grid container columns={gridColTotal}>
          <Grid item xs={sideNavbarSpan} sx={{ display: { xs: "none", md: "block" } }}>
            <Box
              sx={{
                position: "sticky",
                top: `calc(${defaultGridContainerPadding} + ${headerHeight}px)`,
                maxHeight: `calc(100vh - ${defaultGridContainerPadding} - ${headerHeight}px - 40px)`,
              }}
            >
              <SalifyScrollableSideNavbarDefault />
            </Box>
          </Grid>

          <Grid item tablet={contentSpan} mobile={gridColTotal}>
            {!!content?.components?.length && (
              <SalifyStackWrapper components={content.components} stackProps={content.stackProps} />
            )}
          </Grid>
        </Grid>
      </SalifyContainerWrapper>
    </>
  );
};

PageWithStickySideNavbarDefault.displayName = "PageWithStickySideNavbarDefault";

export default PageWithStickySideNavbarDefault;
